// src/components/WhatsAppButton.jsx
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const phoneNumber = "+233277348176"; // Replace with your WhatsApp number
  const message = "Hello, I'm interested in your properties!";

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 group flex items-center">
      {/* Tooltip (with arrow, slides in from the left) */}
      <div className="relative mr-3 opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 bg-black text-white text-xs rounded-md px-3 py-1 whitespace-nowrap pointer-events-none">
        Chat with us
        {/* Arrow */}
        <div className="absolute top-1/2 right-[-6px] -translate-y-1/2 w-0 h-0 border-y-6 border-y-transparent border-l-6 border-l-black"></div>
      </div>

      {/* WhatsApp button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg flex items-center justify-center transition-all"
        style={{
          boxShadow:
            "0 0 15px rgba(34,197,94,0.8), 0 0 30px rgba(34,197,94,0.6)",
          animation: "pulseGlow 2s infinite",
        }}
      >
        <FaWhatsapp size={28} />
        <span className="sr-only">Chat with us on WhatsApp</span>
      </a>

      {/* Glow animation */}
      <style>
        {`
          @keyframes pulseGlow {
            0% { box-shadow: 0 0 10px rgba(34,197,94,0.6), 0 0 20px rgba(34,197,94,0.4); }
            50% { box-shadow: 0 0 20px rgba(34,197,94,0.9), 0 0 40px rgba(34,197,94,0.7); }
            100% { box-shadow: 0 0 10px rgba(34,197,94,0.6), 0 0 20px rgba(34,197,94,0.4); }
          }
        `}
      </style>
    </div>
  );
}
